import React from 'react'

import './styles/buildNumber.css';
import LogManager from './LogManager';

export default function BuildNumver(props) {
    const { buildNumber, version }  = props;
    const logManager = LogManager.getInstance();
    if (window.env === 'prod') {
        logManager.logForSure(
            `[version] \n build: ${buildNumber} \n version: ${version}`
        )
        return ''
    }
    return (
        <div className="build-number">
            build: {buildNumber} <br />
            version: {version}
        </div>
    )
}
